import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/overview" */
    'routes/Extensions/BackInStock/OverviewRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/analytics" */
    'routes/Extensions/BackInStock/AnalyticsRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/connections" */
    'routes/Extensions/BackInStock/ConnectionsRoute'
  )
));

const UpdateBackInStockRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/update" */
    'routes/Extensions/BackInStock/UpdateBackInStockRoute'
  )
));

const InventoryItemsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/inventory-items" */
    'routes/Extensions/BackInStock/InventoryItemsRoute'
  )
));

const SubscribersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/subscribers" */
    'routes/Extensions/BackInStock/SubscribersRoute'
  )
));

const SyncLogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/sync-logs" */
    'routes/Extensions/BackInStock/SyncLogsRoute'
  )
));

const NotificationsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/notifications" */
    'routes/Extensions/BackInStock/NotificationsRoute'
  )
));

const EmailRecipientsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/email-recipients" */
    'routes/Extensions/BackInStock/EmailRecipientsRoute'
  )
));

const EmailAnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/email-analytics" */
    'routes/Extensions/BackInStock/EmailAnalyticsRoute'
  )
));

const EmailConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/backinstock/email-conversions" */
    'routes/Extensions/BackInStock/EmailConversionsRoute'
  )
));


const getBackInStockRoutes = () => {
  return [
    {path: paths.getPathBackInStockOverview(), component: OverviewRoute},
    {path: paths.getPathBackInStockAnalytics(), component: AnalyticsRoute},
    {path: paths.getPathBackInStockConnections(), component: ConnectionsRoute},
    {path: paths.getPathAddBackInStock(), render: (props) => <UpdateBackInStockRoute {...props} isCreate={true} />},
    {path: paths.getPathEditBackInStock(), render: (props) => <UpdateBackInStockRoute {...props} isCreate={false} />},

    {path: paths.getPathBackInStockInventoryItems(), component: InventoryItemsRoute},
    {path: paths.getPathBackInStockSubscribers(), component: SubscribersRoute},
    {path: paths.getPathBackInStockSyncLogs(""), component: SyncLogsRoute},
    {path: paths.getPathBackInStockNotifications(), component: NotificationsRoute},
    {path: paths.getPathBackInStockEmailRecipients(), component: EmailRecipientsRoute},
    {path: paths.getPathBackInStockEmailAnalytics(), component: EmailAnalyticsRoute},
    {path: paths.getPathBackInStockEmailConversions(), component: EmailConversionsRoute},
  ]
}


export { getBackInStockRoutes };
